import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import { buildReadinessColumn } from 'views/shared/ReadinessColumn';
import { canViewOptimiser } from 'library/optimiser';
import config from './config';

export const handlePrepareData = ({
  name, color, duration, activity_type, active, allows_sign_on_windows
}) => ({
  name,
  color,
  duration,
  active,
  allows_sign_on_windows: !!allows_sign_on_windows,
  activity_type_id: activity_type.key
});

const getConfig = () => {
  if (!canViewOptimiser()) return config;
  return {
    ...config,
    list: {
      ...config.list,
      columns: [...config.list.columns, buildReadinessColumn()]
    }
  };
};

const Activity = ({ permissions }) => (
  <Standard
    classes="bhp-activity"
    canAdmin={permissions.CanAdminActivities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.activity,
      list: REDUCER_KEY.activities
    }}
    config={getConfig()}
    permissions={permissions}
    onPrepareData={handlePrepareData}
  />
);

Activity.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Activity;
